import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=7acbecaa&scoped=true"
import script from "./Instruction.js?vue&type=script&lang=js&external"
export * from "./Instruction.js?vue&type=script&lang=js&external"
import style0 from "./Instruction.scss?vue&type=style&index=0&id=7acbecaa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acbecaa",
  null
  
)

export default component.exports